import { FC, memo } from 'react'
import { Row, Button, Icon } from '@/client/components'
import * as S from './styles'
import { getTableContent } from '../helpers'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Controls: FC<any> = memo(({ currentPage, goPrevious, goNext, totalPage, perPage, content }) => (
  <Row end='sm'>
    {currentPage > 1 && (
      <S.ActionButtons>
        <Button kind='dark' onClick={goPrevious}>
          <Icon name='arrow-left' />
          {getTableContent(content, 'prev_button', 'name')}
        </Button>
      </S.ActionButtons>
    )}
    {perPage !== 0 && currentPage * perPage < totalPage && (
      <S.ActionButtons>
        <Button kind='dark' onClick={goNext}>
          {getTableContent(content, 'next_button', 'name')}
          <Icon name='arrow-right' />
        </Button>
      </S.ActionButtons>
    )}
  </Row>
))

Controls.displayName = 'Controls'
